/**
 * Servicio para los literales
 * @author Rubén i Pau
 */
angular.module('mapes')

.factory("Literals", function (NotificationsService,SharedProperties, $q, $http) {

  var apiurl =  SharedProperties.baseUrlService()+"/MOE/services/literals/";
  var literals;

  // carga la configuracion cacheados
  var init = function () {
    return $http.get(apiurl + 'findAll?', {})
    .then(function (data) {
      literals = data.data.literals;
      return literals;
    }, function () {
      NotificationsService.sendMessage("S'ha produit un error", "error");
    });
  };

  var getLiterals = function () {
    return literals;
  };

  var update = function (paramsLiterals) {
    result = {};
    var _params = {};
    _params = Utils.extend({}, _params, paramsLiterals);
    return $http.put( SharedProperties.baseUrlService()+'/MOE/services/literals/update?', _params)
    .then(function (data) {

    }, function () {
      NotificationsService.sendMessage(
          "S'ha produit un error al actualitzar els literals", "danger");
    });

  };

  return {
    init: init,
    getLiterals: getLiterals,
    update: update
  }
})
